<script lang="ts" setup>
import DropdownArrowIcon from '~/assets/icons/arrows/16/chevron-down-filled.svg?component'
import SearchIcon from '~/assets/icons/search-icon/24/search-white.svg?component'
import CloseIcon from '~/assets/icons/close.svg?component'
import NullIcon from '~/assets/icons/search-bar/null.svg?component'
import ArrowIcon from '~/assets/icons/search-bar/arrow.svg?component'

import { useMonitorSize } from '~/composables/monitor-size'
import useAccountStore from '~/shared/store/modules/account'
import useCompaniesStore from '~/shared/store/modules/account/companies'

import customFetch from '~/composables/custom-fetch'
import endpoints from '~/shared/config/api'
import AppButton from '~/components/ui/buttons/AppButton.vue'

import type { IMonitorSize } from '~/shared/interfaces/composables'
import type {
  IShortHistory,
  IShortHistoryItem,
} from '~/shared/interfaces/account/searchHistory'
import type { IMeiliSearch } from '~/shared/interfaces/search/meiliSearch'

const { account } = endpoints

let sizes: IMonitorSize | null = null
const accountStore = useAccountStore()
const companiesStore = useCompaniesStore()
const isGuest = ref(accountStore.userRole === 'guest')

watch(
  () => accountStore.userRole,
  () => {
    isGuest.value = accountStore.userRole === 'guest'
  }
)
let dropListVisible = ref(false)
let resultSearchVisible = ref(false)
let valueSearch = ref('')
let resultSearch = ref<IMeiliSearch | null>(null)
const input = ref<HTMLInputElement>()
let dropSearch = ref({
  name: 'Артикул',
  options: 'По артикулу',
  beta: false,
  id: 'article',
})

const router = useRouter()
const historyList = ref<IShortHistory | null>(null)
const dropList: { name: string; options: string; beta: boolean; id: string }[] =
  [
    {
      name: 'Артикул',
      options: 'По артикулу',
      beta: false,
      id: 'article',
    },
    {
      name: 'Наименование',
      options: 'По наименованию',
      beta: true,
      id: 'name',
    },
  ]
const emits = defineEmits(['openMobileSearch'])

// MeiliSearch
const { search, result } = useMeiliSearch('product_cards')
const params = reactive({
  hitsPerPage: 5,
  page: 1,
})

if (process.client) {
  sizes = useMonitorSize()
}

watch([valueSearch, params], () => {
  if (dropSearch.value.id == 'article') {
    resultSearch.value = null
  } else {
    meiliSearch()
  }
})

async function getSearchHistory() {
  const { data } = await customFetch<IShortHistory>(
    account.getSearchShortHistory()
  )
  if (data?.data.length) {
    historyList.value = data
  }
}

async function meiliSearch() {
  // await search(valueSearch.value, {showRankingScore: true, ...params})
  // resultSearch.value = result
  // return resultSearch
  resultSearch.value = await search(valueSearch.value, {
    filter: ['availability = "true"'],
    showRankingScore: true,
    ...params,
  })
  return resultSearch
}
function methodSearch() {
  if (valueSearch.value.length == 0) return false
  const regValue = /([\%\/\\\&\?\!\+\|\!\@\#\$\<\>\.\^\*])/g
  valueSearch.value = valueSearch.value.replace(regValue, '')
  if (dropSearch.value.id == 'article' && valueSearch.value.length > 1)
    router.push({ path: `/search/${valueSearch.value}` })
  if (dropSearch.value.id == 'name')
    router.push({ path: `/search/query/${valueSearch.value}` })
  resultSearchVisible.value = false
  input.value?.blur()
}

function setSearhCategory(item: {
  name: string
  options: string
  beta: boolean
  id: string
}) {
  dropSearch.value = item
  dropListVisible.value = false
  if (item.id == 'article') {
    resultSearch.value = null
  } else {
    meiliSearch()
  }
}

function SearchBarClear() {
  valueSearch.value = ''
  resultSearchVisible.value = false
  input.value?.focus()
}

function usingSearch() {
  if (!sizes?.isMobile) {
    if (useCookie('token').value) {
      getSearchHistory()
      resultSearchVisible.value = true
    }
  } else {
    input.value?.blur()
    emits('openMobileSearch', sizes?.isMobile)
  }
}

async function deleteSearchRequest(item: IShortHistoryItem, index: number) {
  historyList.value?.data.splice(index, 1)
  const time = new Date(item.created_at)
  const date = `${time.getDate()}.${time.getMonth() + 1}.${time.getFullYear()}`
  const { success } = await customFetch(
    account.deleteSearchHistoryQuery({
      article: item.article,
      brand: item.brand,
      createdAt: `${date} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`,
    })
  )
  if (success) {
    getSearchHistory()
  }
}

async function clearSearchHistory() {
  const { success } = await customFetch(account.clearSearchHistory())
  if (success) {
    historyList.value = null
  }
}
</script>
<template>
  <div
    class="search-bar"
    :class="[
      (resultSearchVisible && !dropListVisible && historyList && 'active') ||
        (resultSearchVisible &&
          !dropListVisible &&
          resultSearch?.hits &&
          valueSearch.length &&
          'active'),
    ]"
  >
    <div
      class="search-bar__content"
      :style="{
        maxWidth: isGuest
          ? '790px'
          : Number(useRuntimeConfig().public.showBalance)
          ? '638px'
          : '720px',
      }"
    >
      <div
        class="search-bar__dropdown medium-500-14"
        tabindex="0"
        :class="[dropListVisible && 'active']"
        @focusout="dropListVisible = false"
      >
        <div class="search-bar__dropdown-container">
          <div
            class="search-bar__dropdown-name"
            @click="dropListVisible = !dropListVisible"
          >
            {{ dropSearch.options }}
            <span class="search-bar__beta" v-if="dropSearch.beta"> Beta </span>
            <DropdownArrowIcon />
          </div>
        </div>
        <div class="search-bar__dropdown-content" v-show="dropListVisible">
          <div class="search-bar__list semiBold-400-16">
            <ul>
              <li
                v-for="itemDrop in dropList"
                @click="setSearhCategory(itemDrop)"
              >
                {{ itemDrop.name }}
                <span class="search-bar__beta" v-if="itemDrop.beta">
                  Beta
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="search-bar__input">
        <input
          type="text"
          placeholder="Найти запчасти"
          v-model="valueSearch"
          @focusin="usingSearch"
          @keyup.enter="methodSearch"
          ref="input"
        />
        <div
          class="search-bar__clear"
          :class="valueSearch.length > 0 ? 'active' : ''"
          @click="SearchBarClear"
        >
          <CloseIcon />
        </div>
        <div
          class="search-bar__results"
          v-show="
            (resultSearchVisible && !dropListVisible) ||
            (historyList && resultSearchVisible && !dropListVisible)
          "
        >
          <div
            class="mailiSearch-block"
            v-if="
              dropSearch.id == 'name' &&
              valueSearch.length &&
              resultSearch?.totalHits
            "
          >
            <div class="search-bar__meilisearch">
              <NuxtLink
                v-for="itemSearch in resultSearch?.hits"
                :to="`/search/${itemSearch.article}/${itemSearch.brand}`"
                @click="resultSearchVisible = false"
              >
                <div class="search-bar__result">
                  <div class="search-bar__img">
                    <NullIcon v-if="!itemSearch.photo" />
                    <nuxt-img
                      v-else
                      :src="itemSearch.photo"
                      loading="lazy"
                      width="44"
                      height="44"
                    />
                  </div>
                  <div class="search-bar__text">
                    <p class="search-bar__description">
                      {{ itemSearch.title }}
                    </p>
                    <p class="search-bar__name">
                      {{ itemSearch.brand }} <span></span>
                      {{ itemSearch.article }}
                    </p>
                  </div>
                </div>
              </NuxtLink>
            </div>
            <div class="search-bar__found">
              <p class="search-bar__count">
                Найдено позиций:
                {{
                  !valueSearch.length || !resultSearch?.hits
                    ? ''
                    : resultSearch?.totalHits
                }}
              </p>
              <AppButton
                text="Посмотреть все"
                type="neutral"
                :href="`/search/query/${valueSearch}`"
                @click="resultSearchVisible = false"
                :icon="ArrowIcon"
                direction="row-reverse"
                size="s"
              />
            </div>
          </div>
          <div class="history-block" v-else-if="historyList">
            <div class="search-bar__results-history">
              <div class="search-bar__title">
                <p>История поиска</p>
                <p @click="clearSearchHistory">Очистить</p>
              </div>
              <div>
                <div
                  class="search-bar__history"
                  v-for="(item, index) in historyList.data"
                >
                  <NuxtLink
                    class="search-bar__link"
                    :to="`/search/${item.article}${
                      item.brand ? '/' + item.brand : ''
                    }`"
                    @click="resultSearchVisible = false"
                  >
                    <p class="search-bar__text">
                      {{ item.brand }} {{ item.article }}
                    </p>
                  </NuxtLink>
                  <div
                    class="search-bar__history-delete svg-fill-black"
                    @click="deleteSearchRequest(item, index)"
                  >
                    <CloseIcon />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="historyList.lastRows > 0" class="search-bar__found">
              <p class="search-bar__count">
                Еще запросов:
                {{ historyList.lastRows < 1 ? 0 : historyList.lastRows }}
              </p>
              <AppButton
                href="/account/search-history"
                @click="resultSearchVisible = false"
                type="neutral"
                :icon="ArrowIcon"
                size="s"
                text="Посмотреть все"
                direction="row-reverse"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="search-bar__button"
        @click="methodSearch"
      >
        <SearchIcon />
      </div>
    </div>
    <Transition name="fade">
      <div
        class="search-bar__body"
        @click="resultSearchVisible = false"
        v-if="
          (resultSearchVisible && !dropListVisible && historyList) ||
          (resultSearchVisible &&
            !dropListVisible &&
            resultSearch?.hits &&
            valueSearch.length)
        "
      ></div>
    </Transition>
  </div>
</template>
<style lang="scss" scoped>
.search-bar {
  margin: 0 16px;
  width: 100%;

  &.active {
    .search-bar {
      &__content {
        outline-color: transparent;
      }
    }
  }

  &__empty {
    text-align: center;
    color: $content_secondary;
    padding: 20px 0;
  }

  &__content {
    background: $bg_page;
    border-radius: 8px;
    outline: 2px solid $control-border_orange;
    width: 100%;
    height: 48px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 105;

    @include md-breakpoint {
      max-width: none !important;
    }
  }

  &__body {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh + 48px);
    background: #3535341a;
    z-index: 1;
  }

  &__input {
    //max-width: 550px;
    width: 100%;
    padding: 0 48px 0 0;

    input {
      width: 100%;
      padding-right: 30px;
      padding-left: 12px;
      @include font(16px, 20px);

      @include md-breakpoint {
        padding-left: 16px;
      }

      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        transition: color 0.3s ease;
      }

      &:focus::placeholder {
        color: transparent;
      }
    }
  }

  &__link {
    width: 100%;
  }

  &__text {
    max-width: 96%;
    overflow: hidden;
    word-wrap: none;
    text-overflow: ellipsis;
  }

  &__clear {
    position: absolute;
    right: 56px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;

    &.active {
      opacity: 1;
      transition: opacity 0.3s ease;
    }

    &:hover:not(:active) {
      @include mf-breakpoint {
        svg {
          :deep(path) {
            fill: $content_primary;
          }
        }
      }
    }
  }

  &__dropdown {
    cursor: pointer;
    position: relative;
    max-width: fit-content;
    width: 100%;

    &.active {
      svg {
        transform: rotate(180deg);
      }
    }

    &-container {
      min-width: 123px;
      width: 100%;
      height: 100%;
      max-height: 40px;
      padding: 12px 8px;
      border-radius: 5px;
      background-color: $control-bg_neutral;
      margin: 2px 0 2px 4px;
      transition: background-color 0.3s;

      &:hover:not(:active) {
        @include mf-breakpoint {
          background-color: $control-bg_neutral-hover;
        }
      }
    }

    &-content {
      position: absolute;
      top: 48px;
      left: 2px;
      z-index: 110;
      padding: 0 8px;
      border-radius: 5px;
      width: 100%;
      max-width: 164px;
      box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1019607843);
      background-color: $bg_page;
    }

    &-name {
      @include font(14px, 20px, 500);
      display: flex;
      justify-content: space-between;
      align-items: center;
      white-space: nowrap;
      gap: 4px;
      margin-top: -2px;

      span {
        position: absolute;
        top: -13px;
        left: 4px;
        z-index: 7;
      }

      svg {
        transition: transform 0.3s;
      }
    }

    img {
      padding-left: 7px;
    }

    @include md-breakpoint {
      display: none;
    }
  }

  &__button {
    position: absolute;
    right: -2px;
    width: 48px;
    height: 48px;
    background-color: $control-bg_primary;
    border-radius: 8px;
    min-width: 48px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover:not(:active) {
      @include mf-breakpoint {
        background-color: $control-bg_primary-hover;
      }
    }
  }

  &__list {
    padding-top: 8px;

    ul {
      li {
        padding: 10px 0;
        @include font(14px, 20px);

        &:hover {
          color: $content_orange;
        }
      }
    }
  }

  &__beta {
    @include font(14px, 16px, 500);
    background: $content_primary;
    width: 46px;
    height: 20px;
    padding: 3px 8px;
    border-radius: 18px;
    color: $content_white;
    display: flex;
    align-items: center;
  }

  &__results {
    position: absolute;
    top: calc(100% + 6px);
    background: $bg_page;
    overflow: hidden;
    z-index: 4;
    width: 100%;
    left: 0;
    border-radius: 8px;
    padding: 0 4px;
  }

  &__meilisearch {
    padding: 4px 0;
  }

  &__description {
    transition: 0.3s color ease;
  }

  &__result {
    padding: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.3s ease;
    border-radius: 6px;

    &:hover {
      background: $control-bg_neutral;

      .search-bar__description {
        color: $control-content_orange;
      }
    }
  }

  &__img {
    max-width: 44px;
    max-height: 44px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  &__text {
    p {
      @include font(14px, 20px, 400);

      &:last-child {
        color: $content_secondary;
        gap: 6px;
        display: flex;
        align-items: center;

        span {
          background: $content_icons;
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
        }
      }
    }
  }

  &__found {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 8px;
    border-top: 1px solid $bg_border;

    p {
      @include font(14px, 16px, 400);
      color: $content_secondary;
      padding-top: 4px;
    }
  }

  &__history {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    padding: 12px 8px;
    transition: 0.3s;
    position: relative;

    &:hover {
      background-color: $bg_light-grey;
    }

    a {
      flex: 1;
      @include font(16px, 20px, 400);
    }

    &-delete {
      display: flex;
      cursor: pointer;
      position: absolute;
      right: 12px;
      z-index: 20;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 8px;

    p {
      &:first-child {
        @include font(16px, 20px, 500);
      }

      &:last-child {
        @include font(14px, 16px);
        color: $content_secondary;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: $content_primary;
        }
      }
    }
  }

  @include md-breakpoint {
    margin: 0;
  }
}
</style>
